import * as actionTypes from './actionTypes';


export const onUploadFileSuccess = (response,supportedFiles)=>{
    return {
        type:actionTypes.UPLOAD_FILE_SUCCESS,
        response:response,
        supportedFiles:supportedFiles
    }
};

export const onUploadFileFailed = (error)=>{
    return {
        type:actionTypes.UPLOAD_FILE_FAILED,
        error
    }
};

export const onUpdateLicenseFiles = (response)=>{
    return {
        type:actionTypes.UPDATE_LICENSE_FILES,
        response
    }
};

export const onUpdateEmployementFiles = (response)=>{
    return {
        type:actionTypes.UPLOAD_EMPLOYEMENT_FILES,
        response
    }
};


export const uploadFileStart  = (file,source,docType) =>{
    return  {
        type: actionTypes.UPLOAD_FILE,
        file,
        source,
        docType
    };
};